/** @format */

import React from 'react';
import Page from 'src/components/Page';
import { WelcomeTitle } from '../../components';
import useAuth from 'src/hooks/useAuth';

import { useTranslation } from 'react-i18next';
import Breadcrumb from 'src/components/Breadcrumb';
import SurveyModal from 'src/components/surveyModal';
import { useDispatch, useSelector } from 'src/store';

export const scenarioRequiredFields = {
  driver: ['postalCode', 'country', 'company'],
  fleet: ['postalCode', 'role', 'street', 'city', 'company', 'country'],
  'workshop-cv': ['postalCode', 'street', 'city', 'company', 'country'],
  'workshop-pv': ['postalCode', 'street', 'city', 'company', 'country'],
  partner: ['postalCode', 'street', 'city', 'company', 'country'],
  authority: ['postalCode', 'street', 'city', 'company', 'country'],
  trainer: ['postalCode', 'street', 'city', 'company', 'country'],
  'conti-internal': ['postalCode', 'company'],
  'kaas-customer': ['postalCode', 'company'],
  'maps-on-demand-customer': ['postalCode', 'company'],
  'maps-on-demand-customer-nissan': ['postalCode', 'company'],
  'maps-on-demand-customer-nissan-isa': ['postalCode', 'company'],
  'maps-on-demand-customer-nissan-tiny': ['postalCode', 'company'],
  'maps-on-demand-customer-mitsubishi': ['postalCode', 'company'],
  'maps-on-demand-customer-renault': ['postalCode', 'company'],
  'tolling-proxy-customer': ['postalCode', 'company']
};

export const missingRequiredFieldsChecking = user => {
  // Checking scenario and role
  if (!user.scenario) return true;
  if (scenarioRequiredFields[user.scenario] && scenarioRequiredFields[user.scenario].includes('role') && !user.role) {
    return true;
  }
  if (user.role && user.role === 'other' && !user.roleOther) {
    return true;
  }

  // Checking required fields
  if (scenarioRequiredFields[user.scenario]) {
    if (scenarioRequiredFields[user.scenario].includes('postalCode') && !user?.address?.postalCode) return true;
    if (scenarioRequiredFields[user.scenario].includes('street') && !user?.address?.street) return true;
    if (scenarioRequiredFields[user.scenario].includes('city') && !user?.address?.city) return true;
    if (scenarioRequiredFields[user.scenario].includes('country') && !user.address.country) return true;
    if (scenarioRequiredFields[user.scenario].includes('company') && !user.company) return true;
  }

  return false;
};

const SurveyView = () => {
  const { user } = useAuth();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { userData } = useSelector(state => state.users);

  const breadcrumbData = [
    {
      title: t('Survey')
    }
  ];

  useEffect(() => {
    if (user && Object.keys(user).length > 0 && ((userData && Object.keys(userData).length === 0) || !userData)) {
      dispatch(setUserData({ ...user }));
    }
  }, [user, dispatch]);

  return (
    <Page className={`dashboard`} title="Dashboard">
      <Breadcrumb data={breadcrumbData} />
      <WelcomeTitle>
        {user && user.firstName && t('welcome')} {user && user.firstName} {user && user.lastName}
        {user && user.firstName && '!'}
      </WelcomeTitle>
      <SurveyModal />
    </Page>
  );
};

export default SurveyView;
